<template>
  <div
    id="vgsi-solutions"
    class="vgsi-solutions">
    <div
      v-if="solutions"
      class="vgsi-solutions__wrap"
    >
      <!-- cop panel -->
      <Panel
        :solutions="solutions"
        :hotline="hotline"
        :more="more"
        :current-floor="currentFloor"
      />
      <!-- //cop panel -->
      <!--- slider -->
      <div
        v-if="solutions"
        class="vgsi-solutions__slick">
        <slick
          ref="slick"
          :options="slickOptions"
          @reInit="handleReInit"
          @afterChange="handleAfterChange"
        >
          <Slide
            v-for="(item, index) in solutions"
            :key="index"
            :prop-slide="item"
          />
        </slick>
      </div>
      <!-- // end slider -->
    </div>
  </div>
</template>

<script>
import Slick from 'vue-slick'
import Slide from '../components/Slide'
import Panel from '../components/Panel'
import jQuery from 'jquery'
export default {
  name: 'VgsiSolutions',
  components: {
    Slick,
    Slide,
    Panel
  },
  data () {
    return {
      solutions: null,
      hotline: null,
      more: null,
      currentFloor: 0,
      slickOptions: {
        slidesToShow: 1,
        accessibility: true,
        adaptiveHeight: true,
        arrows: false,
        dots: true,
        draggable: true,
        speed: 600,
        swipe: true,
        vertical: true
        // Any other options that can be got from plugin documentation
      }
    }
  },
  mounted () {
    this.initData()
    this.sub = this.$geb.getFilteredBus({ id: 'levelPress' }).subscribe(data => {
      let btnLabel = 'slick-slide-control0' + data.payload
      const btnElm = document.getElementById(btnLabel)
      btnElm.click()
      this.snaptoSection()
    })
  },
  methods: {
    initData () {
      this.$nextTick(() => {
        this.solutions = this.$root.solutions
        this.hotline = this.$root.hotline
        this.more = this.$root.more
      })
    },
    handleAfterChange (event, slick, currentSlide) {
      this.currentFloor = currentSlide
    },
    handleReInit () {
      this.$refs.slick.slick('refresh')
    },
    snaptoSection () {
      jQuery('html, body').animate({
        scrollTop: jQuery('#vgsi_solutions_row').offset().top - 100
      })
    }
  }
}
</script>
<style lang="scss">
$blue-color: #006893;
html {
  scroll-behavior: smooth;
}
.slick-slider {
  position: relative;
  display: block;
  box-sizing: border-box;
  user-select: none;
  -webkit-touch-callout: none;
  -khtml-user-select: none;
  -ms-touch-action: pan-y;
  touch-action: pan-y;
  -webkit-tap-highlight-color: transparent;
}

.slick-list {
  position: relative;
  display: block;
  overflow: hidden;
  margin: 0;
  padding: 0;

  &:focus {
    outline: none;
  }

  &.dragging {
    cursor: pointer;
    cursor: hand;
  }
}

.slick-slider {
  .slick-track, .slick-list {
    transform: translate3d(0, 0, 0);
  }
}

.slick-track {
  position: relative;
  top: 0;
  left: 0;
  display: block;
  margin-left: auto;
  margin-right: auto;

  &:before {
    display: table;
    content: '';
  }

  &:after {
    display: table;
    content: '';
    clear: both;
  }
}

.slick-loading .slick-track {
  visibility: hidden;
}

.slick-slide {
  display: none;
  float: left;
  height: 100%;
  min-height: 1px;
}

[dir='rtl'] .slick-slide {
  float: right;
}

.slick-slide {
  img {
    display: block;
  }

  &.slick-loading img {
    display: none;
  }

  &.dragging img {
    pointer-events: none;
  }
}

.slick-initialized .slick-slide {
  display: block;
}

.slick-loading .slick-slide {
  visibility: hidden;
}

.slick-vertical .slick-slide {
  display: block;
  height: auto;
  border: 1px solid transparent;
}

.slick-arrow.slick-hidden {
  display: none;
}
.slick-dots {
  // display: none !important;
  position: absolute;
  top: 2rem;
  right: 2rem;
  z-index: 100;
  opacity: 0;
}
/*--vgsi-solutions-*/
.vgsi-solutions {
  position: relative;
  overflow: hidden;
  position: 0;
  margin: 0;
  box-sizing: border-box;
}

</style>
